import round from 'helpers/mathRound';
import { getAlleDiscount } from 'pages/quotes/helpers';


export const calculateTotals = (items, customerPushCart, quoteProducts) => {
  const {
    subTotal,
    discount,
    totalAdditionalSubscriptionPrice,
    totalSubscription
  } = items.reduce(
    (totals, item) => {
      const {
        qty,
        fixedPrice,
        savings,
        additionalSubscriptionPrice,
        subscription_id,
        sku,
        subscriptionFrequency
      } = item;
      const productData = customerPushCart?.products[sku]?.product || quoteProducts?.find((item) => item?.sku === sku);
      const itemSubTotal = parseFloat(fixedPrice) * qty || 0;
      //TODO: remove calculation of Alle discount as it should be calculated as simple discount
      // after customer confirmation of new flow
      const isAlleSKU = sku.includes('bdsku');
      const itemDiscount = isAlleSKU
        ? round(getAlleDiscount(productData)) || 0
        : parseFloat(savings) || 0;

      const itemAdditionalSubscriptionPrice =  parseFloat(additionalSubscriptionPrice) || 0;
      const itemSubscriptionPrice = (subscription_id && subscriptionFrequency) ? itemSubTotal : 0;

      return {
        subTotal: totals.subTotal + round(itemSubTotal),
        discount: totals.discount + itemDiscount,
        totalAdditionalSubscriptionPrice: round(totals.totalAdditionalSubscriptionPrice) + round(itemAdditionalSubscriptionPrice),
        totalSubscription: round(totals.totalSubscription) + round(itemSubscriptionPrice)
      };
    },
    { subTotal: 0, discount: 0, totalAdditionalSubscriptionPrice: 0, totalSubscription: 0 }
  );
  const total = subTotal - discount;

  return {
    subTotal,
    discount,
    totalAdditionalSubscriptionPrice,
    totalSubscription,
    total,
  };
};
